import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { VentaRequest } from "@/features/inventario/ventas/api/add-venta";
import { Venta } from "@/shared/types/venta";

export interface CreateVentaConFECreditoRequest {
  iTipTra: number;
  iTipEmi: number;
  iIndPres: number;
  dCondTiCam: number;
  dDesIndPres?: string;
  informacionAdicional?: string;
  dTiCam?: number;
  monedaOperacionId?: string;
  ventaRequest: VentaRequest;
}

export interface FacturaElectronicaDto {
  cdc: string;
  numeroDE: string;
  kudeBase64?: string;
}

export interface CreateVentaConFECreditoResponseData {
  venta: Venta;
  facturaElectronica?: FacturaElectronicaDto;
}

export interface CreateVentaConFECreditoResponse {
  success: boolean;
  message: string;
  data: CreateVentaConFECreditoResponseData;
}

export async function createVentaConFECredito(request: CreateVentaConFECreditoRequest): Promise<CreateVentaConFECreditoResponseData> {
  await sleep(1000);
  const response = await api.post<CreateVentaConFECreditoResponse>("ventas/crear-con-fe", request);
  return response.data.data;
}

export function useCreateVentaConFECreditoMutation(mutationConfig: MutationConfig<CreateVentaConFECreditoResponseData, CreateVentaConFECreditoRequest> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: createVentaConFECredito,
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["ventas"] });
    },
  })
}

export interface CreateVentaConFECreditoMutationProps {
  mutationConfig?: MutationConfig<CreateVentaConFECreditoResponseData, CreateVentaConFECreditoRequest>
  children?: (mutationResult: MutationResult<CreateVentaConFECreditoResponseData, CreateVentaConFECreditoRequest>) => ReactNode
}

export function CreateVentaConFECreditoMutation({
  mutationConfig,
  children
}: CreateVentaConFECreditoMutationProps) {
  const mutationResult = useCreateVentaConFECreditoMutation(mutationConfig);
  return children && children(mutationResult);
}
